import { LOCALES } from '@mentorivo/shared/locales';

import { DASH_HOME } from '@/lib/dash-home';
import { setupPath } from '@/lib/onboarding';

/**
 * Girişten sonra nereye dönüleceği — giriş/kayıt formu ve postadaki giriş
 * bağlantısının sayfası (`/auth/link`) ortak kullanıyor (10 Eki 2026).
 */

/** `/de/dashboard` → `/dashboard`. Router öneki kendisi ekliyor; iki kez eklenmesin. */
const LOCALE_PREFIX = new RegExp(`^/(${LOCALES.join('|')})(?=/|$)`);

/**
 * Uygulama içi, öneksiz yol ya da `null`.
 *
 * Yalnızca `/` ile başlayan, `//` ile başlamayan yollar kabul ediliyor —
 * aksi hâlde `?next=https://baska-site` yazan biri, bizim giriş sayfamızı
 * kendi sitesine açılan bir kapıya çevirebilirdi (open redirect). Sunucu da
 * aynı kuralı uyguluyor (`emailSignInStartSchema` → `next`).
 *
 * 🔴 Önek soyma 13 dilin HEPSİNİ tanıyor. Eskiden yalnız `en|tr` soyuluyordu:
 * `?next=/de/dashboard` ile gelen Almanca kullanıcı `/de/de/dashboard`a
 * gönderilip 404 görüyordu.
 */
export function safeAppPath(raw: string | null | undefined): string | null {
  if (!raw || !raw.startsWith('/') || raw.startsWith('//') || raw.includes('\\')) return null;
  const stripped = raw.replace(LOCALE_PREFIX, '');
  return stripped === '' ? null : stripped;
}

/**
 * Giriş sayfasının `?next=` değeri — `proxy.ts` korumalı bir sayfadan
 * çevirdiğinde ekliyor. `useSearchParams` yerine `window.location`: o kanca
 * sayfayı Suspense sınırına bağlıyor ve tüketiciler zaten istemcide.
 */
export function returnPathFromLocation(): string | null {
  if (typeof window === 'undefined') return null;
  return safeAppPath(new URLSearchParams(window.location.search).get('next'));
}

/**
 * `next` üye olunmayan bir alanı gösteriyorsa panelin girişine düşer.
 *
 * Çıkış yapınca giriş sayfası `?next=/tr/dashboard/w/<eski alan>/…` taşıyor.
 * Aynı tarayıcıda BAŞKA bir hesapla girilirse o adres yeni kişiye 404
 * ("Bu adreste bir ekran yok") veriyordu — 23 Eyl 2026'da yaşandı. API'deki
 * Google dönüşü aynı kuralı `nextForMember` ile uyguluyor.
 */
export function memberPath(path: string | null, memberSlugs: string[]): string {
  if (!path) return DASH_HOME;
  const match = /^\/dashboard\/w\/([^/?#]+)/.exec(path);
  if (match && !memberSlugs.includes(decodeURIComponent(match[1] ?? ''))) return DASH_HOME;
  return path;
}

/**
 * Kod ya da bağlantıyla girişten sonraki adres.
 *
 * YENİ hesap kurulum sihirbazına gidiyor (alan plansız, kabuk zaten oraya
 * yollardı — doğrudan gitmek bir yönlendirme turunu atlıyor). Tek istisna
 * panel DIŞI bir dönüş yolu (ör. `/invite/...`): kişi oraya bir iş için
 * geldi, sihirbaz onu beklesin.
 */
export function afterSignInPath(
  session: { created: boolean; next: string | null; workspaces: { slug: string }[] },
  localNext: string | null,
): string {
  const next = safeAppPath(session.next) ?? localNext;
  if (session.created && (!next || next.startsWith('/dashboard'))) return setupPath();
  return memberPath(next, session.workspaces.map((w) => w.slug));
}
